import { getCommentRecordId, getReplyRecordId } from './commentIds';

/**
 * Assigns stable `id` fields to legacy comments/replies that were stored
 * without one. Returns whether any record was updated.
 */
export const normalizeCommentsWithIds = (comments = []) => {
  let changed = false;

  const normalized = comments.map((comment, commentIndex) => {
    const existingCommentId = getCommentRecordId(comment);
    const commentId =
      existingCommentId ||
      `_legacy_c_${comment.userId || 'anon'}_${commentIndex}_${
        comment.timestamp?.seconds ?? ''
      }`;
    if (!existingCommentId) changed = true;

    const replies = (comment.replies || []).map((reply, replyIndex) => {
      const existingReplyId = getReplyRecordId(reply);
      if (existingReplyId) return reply;

      changed = true;
      return {
        ...reply,
        id: `_legacy_r_${reply.userId || 'anon'}_${commentIndex}_${replyIndex}_${
          reply.timestamp?.seconds ?? ''
        }`,
      };
    });

    if (existingCommentId && replies === comment.replies) {
      return comment;
    }

    return { ...comment, id: commentId, replies };
  });

  return { comments: normalized, changed };
};
